module.exports = __webpack_public_path__ + "img/mgh-nagoya@2x.d1af2726.jpg";